var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQwikWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 12,
    viewBox: "0 0 47 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.394 0c2.866 0 5.08 1.59 5.08 4.488 0 2.144-.897 3.89-2.402 4.927l.955.966L13.247 12l-1.534-1.647a6.94 6.94 0 0 1-1.23.113c-2.219 0-4.116-1.044-4.768-2.937L1.48 6.425h4.01v-.006h1.42L5.521 5.183c.019-.16.043-.316.071-.47L0 3.196h7.724l-1.06-.962C7.71.84 9.38 0 11.394 0zm-.087 2.272c-1.81-.014-2.75 1.747-2.75 3.636 0 .951.362 1.732 1.086 2.116l1.722-1.392.955.98c.71-.668 1.072-1.79 1.072-3.025 0-1.25-.637-2.3-2.085-2.315z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.702 6.59 2.49-6.448h2.504l.579 6.504L28.706.142h2.736l-4.125 10.154h-2.91l-.593-6.192-2.547 6.192H18.27L17.402.142h3.01l.29 6.447zM33.98 10.296h-2.996L32.618.142h2.996L33.98 10.296zM39.995 4.175l3.82-4.033H47L42.31 5l3.083 5.297h-3.199L39.72 5.879l-.709 4.417h-2.982L37.664.142h2.982l-.651 4.033z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQwikWhite);
export default __webpack_public_path__ + "static/media/qwik-white.9933aa5f3c91c2299da5880fb2d65cb0.svg";
export { ForwardRef as ReactComponent };